import { TermModalProps } from './types/term';
import DialogModal from '../../components/DialogModal';
import { Box, Button, CircularProgress, TextField } from '@mui/material';
import { StyledButton } from '../Exams/styled';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import terms from '../../apis/terms';

const AddTermModal: React.FC<TermModalProps> = ({
  fetchData,
  open,
  onClose,
  onApiSuccessAndFailure
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [name, setName] = useState<string>('');

  const { user: loggedInUser } = useSelector(
    (state: RootState) => state.profile
  );

  const handleSubmit = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    const payload = { name };

    try {
      const response = await terms.upsertTerm(loggedInUser.school, payload);
      if (response) {
        fetchData();
        const message = `Term added succesfully`;
        onApiSuccessAndFailure(true, message);
      }
    } catch (error: any) {
      onApiSuccessAndFailure(false, error.errors[0].message);
    } finally {
      setIsSubmitting(false);
      setName('');
    }
  };

  return (
    <>
      <DialogModal
        open={open}
        onClose={onClose}
        title='Add Term'
        actions={
          <>
            <Button onClick={onClose} color='primary' variant='outlined'>
              Cancel
            </Button>
            <StyledButton
              onClick={handleSubmit}
              disabled={isSubmitting || !name.trim()}
            >
              {isSubmitting ? (
                <CircularProgress size={24} color='inherit' />
              ) : (
                'Add'
              )}
            </StyledButton>
          </>
        }
      >
        <Box>
          <TextField
            fullWidth
            id='name'
            name='name'
            label='Term Name'
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            required
            placeholder='Enter term name'
          />
        </Box>
      </DialogModal>
    </>
  );
};

export default AddTermModal;
